export const BASE_URL = `${process.env.NEXT_PUBLIC_BE_URL}/${process.env.NEXT_PUBLIC_BE_API}`;
export const BASE_LISTING_URL = `${process.env.NEXT_PUBLIC_LISTING_BE_URL}/${process.env.NEXT_PUBLIC_BE_API}`;
export const BASE_AUTH_URL = `${process.env.NEXT_PUBLIC_AUTH_BE_URL}/${process.env.NEXT_PUBLIC_BE_API}`;
export const BASE_BOOKING_URL = `${process.env.NEXT_PUBLIC_BOOKING_BE_URL}/${process.env.NEXT_PUBLIC_BE_API}`;
export const BASE_PAYMENT_URL = `${process.env.NEXT_PUBLIC_PAYMENT_BE_URL}/${process.env.NEXT_PUBLIC_BE_API}`;
export const BASE_MESSAGES_URL = `${process.env.NEXT_PUBLIC_MESSAGES_BE_URL}/${process.env.NEXT_PUBLIC_BE_API}`;
export const SOCKET_URL = `${process.env.NEXT_PUBLIC_MESSAGES_BE_URL}`;
